import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useCustomer} from "../hooks/useCustomer.ts";
import {Customer, CustomerStatus} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {

    const {
        createRecord,
    } = useCustomer();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                description: '',
                status: 'ACTIVE' as CustomerStatus,
                contactInfo: {
                    email: '',
                    phone: '',
                    website: ''
                }
            } as Customer}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
